// src/constants/shedModels.js
// Catalog of shed models offered by SE Yard Solutions / homedepotshed.com.
//
// SINGLE SOURCE OF TRUTH for model order, sizes, and base prices. Edwin's
// 6/22/2026 price email is authoritative — models are listed in the exact
// order he asked for, each size in the order he wrote it, with the base price
// (the shed itself; configurator add-ons price on top).
//
// Used by:
//   - Public /inventory model chooser + "starting at" pricing + card order
//   - Homepage model cards (renders this array in order)
//   - The /configure builder (base price per model + size — see builderConfig.js)
//   - Admin shed-creation form (size dropdown filters by selected model)
//   - Model archive pages (/inventory?model=...)

export const SHED_MODELS = [
  {
    slug: 'spartan',
    name: 'The Spartan',
    category: 'Value Gable',
    baseDoor: 'Double Doors',
    // Edwin's order (column-by-column as emailed)
    sizes: ['10x10', '12x12', '16x16', '10x12', '12x16', '16x20', '10x16', '12x20', '16x24', '10x20', '12x24', '16x28', '10x24', '12x28', '16x32'],
    prices: {
      '10x10': 3500, '12x12': 4680, '16x16': 7168,
      '10x12': 3900, '12x16': 5376, '16x20': 8800,
      '10x16': 4880, '12x20': 6720, '16x24': 10368,
      '10x20': 5600, '12x24': 7200, '16x28': 11872,
      '10x24': 6480, '12x28': 8232, '16x32': 13312,
    },
  },
  {
    slug: 'chisholm',
    name: 'The Chisholm',
    category: 'Small Value Gable',
    baseDoor: '43" single door',
    sizes: ['8x8', '8x10', '8x12', '8x16', '8x20'],
    prices: {
      '8x8': 2384, '8x10': 2800, '8x12': 3264, '8x16': 3968, '8x20': 4960,
    },
  },
  {
    slug: 'gridiron',
    name: 'GridIron',
    category: 'Value Barn',
    baseDoor: 'Double Doors',
    sizes: ['10x10', '12x12', '16x16', '10x12', '12x16', '16x20', '10x16', '12x20', '16x24', '10x20', '12x24', '16x28', '10x24', '12x28', '16x32'],
    prices: {
      '10x10': 4045, '12x12': 5288, '16x16': 7956,
      '10x12': 4401, '12x16': 6074, '16x20': 9768,
      '10x16': 5336, '12x20': 7593, '16x24': 11508,
      '10x20': 5980, '12x24': 8136, '16x28': 13177,
      '10x24': 6900, '12x28': 9302, '16x32': 14776,
    },
  },
  {
    slug: 'verde',
    name: 'The Verde',
    category: 'Garden Shed',
    baseDoor: "5' double door",
    sizes: ['8x10', '10x10', '8x12', '10x12', '12x16', '10x16', '12x20', '10x20', '12x24'],
    prices: {
      '8x10': 3200, '10x10': 4145,
      '8x12': 3840, '10x12': 4515, '12x16': 6268,
      '10x16': 5450, '12x20': 7128,
      '10x20': 7089, '12x24': 8695,
    },
  },
  {
    slug: 'uptown',
    name: 'The Uptown',
    category: 'Modern Studio',
    baseDoor: null,
    sizes: ['8x12', '10x12', '12x12', '8x16', '10x16', '12x16', '10x20', '12x20', '12x24'],
    prices: {
      '8x12': 4032, '10x12': 4300, '12x12': 6192,
      '8x16': 5376, '10x16': 6720, '12x16': 8256,
      '10x20': 8400, '12x20': 9840, '12x24': 11808,
    },
  },
  {
    slug: 'element',
    name: 'The Element',
    category: 'Essential Series',
    baseDoor: null,
    sizes: ['8x8', '10x10', '12x12', '8x10', '10x12', '12x16', '8x12', '10x16', '12x20', '8x16', '10x20', '12x24'],
    prices: {
      '8x8': 1920, '10x10': 2700, '12x12': 3744,
      '8x10': 2240, '10x12': 3120, '12x16': 4608,
      '8x12': 2592, '10x16': 3840, '12x20': 5520,
      '8x16': 3328, '10x20': 4800, '12x24': 6192,
    },
  },
  {
    slug: 'ranger',
    name: 'The Ranger',
    category: 'Gable Cabin',
    baseDoor: null,
    sizes: ['12x16', '16x20', '10x16', '12x20', '16x24', '10x20', '12x24', '16x28', '10x24', '12x28', '16x32'],
    prices: {
      '12x16': 6166, '16x20': 9750,
      '10x16': 5530, '12x20': 7510, '16x24': 11318,
      '10x20': 5600, '12x24': 7990, '16x28': 12822,
      '10x24': 7130, '12x28': 9022, '16x32': 14262,
    },
  },
  {
    slug: 'desperado',
    name: 'Desperado',
    category: 'Barn Cabin',
    baseDoor: null,
    // Edwin's email listed "12x2 $8,383" — confirmed as 12x20 (a dropped digit;
    // fits the price gradient between 12x16 $6,864 and 12x24 $8,926).
    sizes: ['16x16', '12x16', '16x20', '10x16', '12x20', '16x24', '10x20', '12x24', '16x28'],
    prices: {
      '16x16': 8906,
      '12x16': 6864, '16x20': 10718,
      '10x16': 5986, '12x20': 8383, '16x24': 12458,
      '10x20': 6630, '12x24': 8926, '16x28': 14127,
    },
  },
];

export const MODEL_NAMES = SHED_MODELS.map((m) => m.name);
export const MODEL_CATEGORIES = [...new Set(SHED_MODELS.map((m) => m.category))];

export const getModelByName = (name) => SHED_MODELS.find((m) => m.name === name);

export const getModelBySlug = (slug) => SHED_MODELS.find((m) => m.slug === slug);

const findModel = (nameOrSlug) =>
  SHED_MODELS.find((m) => m.name === nameOrSlug || m.slug === nameOrSlug) ||
  // tolerate case / "The " prefix differences coming from DB rows or URLs
  SHED_MODELS.find((m) => {
    const q = String(nameOrSlug || '').trim().toLowerCase();
    return (
      m.slug.toLowerCase() === q ||
      m.name.toLowerCase() === q ||
      m.name.toLowerCase().replace(/^the\s+/, '') === q.replace(/^the\s+/, '')
    );
  });

export const getSizesForModel = (nameOrSlug) => findModel(nameOrSlug)?.sizes ?? [];

/** Resolve any model name/slug/URL value to its canonical slug (or null). */
export const getModelSlug = (nameOrSlug) => findModel(nameOrSlug)?.slug ?? null;

/** Lowest base price for a model — the "starting at" figure on listings. */
export const getStartingPrice = (nameOrSlug) => {
  const model = findModel(nameOrSlug);
  if (!model) return null;
  const values = Object.values(model.prices);
  return values.length ? Math.min(...values) : null;
};

/** Base price (dollars) for one model + size, e.g. ("spartan", "10x12"). */
export const getPriceForSize = (nameOrSlug, size) => {
  const model = findModel(nameOrSlug);
  if (!model || !size) return null;
  return model.prices[String(size).toLowerCase().replace(/\s+/g, '')] ?? null;
};
